/**
 * Identifica o relatório ICMS-ST (alinhado à api-relatorios exportarRelatorioIcmsSt).
 * @param {string | null | undefined} nome
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioIcmsSt(nome, codigoRelatorio) {
  const nomeUpper = (nome ?? "").toUpperCase();
  const codigoUpper = (codigoRelatorio ?? "").toUpperCase();
  return (
    codigoUpper === "ICMS_ST" ||
    codigoUpper.includes("ICMS_ST") ||
    nomeUpper.includes("ICMS-ST") ||
    /ICMS[\s\-_]?ST/i.test(nome ?? "")
  );
}
